/* eslint-disable */
export enum PolicyStatus {
  Unknown = 0,
  Offer,
  Policy,
  Amended,
  Renewed,
  Terminated,
  Rejected,
}